<template>
  <div class="common-reply">

      <vx-list
        class="main"
        style="height:100%;"
        :api="api"
        :params="params"
        :enableAutoScrollTop="false"
        @load="onload"
        ref="vxlist"
      >
        <slot></slot>

        <div class="b2" v-if="contentGlobalStatus == 2 || contentGlobalStatus == null">
          <!-- 回复部分 -->
          <div class="til">
            <div class="t1">全部回复</div>
            <div class="t2">（{{ allReplyNum }}）</div>
          </div>

          <template v-if="replyList.length > 0">
            <div class="reply" v-for="(item, index) in replyList" :key="item.id">
              <!-- <div class="pho"></div> -->
              <img class="pho" :src="item.replyPhoto.url" alt="" />
              <div class="info">
                <div class="l1">
                  <div class="l1l">
                    {{ item.replyName }}
                    <template v-if="item.replyType == 2">({{item.studentNames}})</template>
                  </div>
                  <template v-if="fromType==0">
                    <div
                      v-if="item.reply == selfId"
                      class="l1r r2 flex-center"
                      @click="deleteArchivesReply(item.id, index)"
                    >
                      <van-icon class="icon" name="delete-o" />
                      删除
                    </div>
                    <div v-else class="l1r r1 flex-center" @click="openInput($event, item)">
                      <van-icon class="icon" name="chat-o" size="16px" />
                      回复
                    </div>
                  </template>
                </div>
                <div class="l2">
                  {{ item.createTime | formatGoodDate() }}
                </div>
                <div class="l3">
                  <template v-if="item.replied">
                    <span>回复 </span>
                    <span class="l31">{{ item.repliedName }}：</span>
                  </template>
                  <span> {{ item.replyContent.list[0].content }}</span>
                </div>
              </div>
            </div>
          </template>
          <van-empty
            v-else
            image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
            image-size="128"
            style="padding: 16px 0"
            description="暂无回复～"
          >
          </van-empty>
        </div>
      </vx-list>
      <template v-if="fromType==0">
        <div class="inp-wrap" v-if="contentGlobalStatus == 2 || contentGlobalStatus == null">
          <van-field placeholder="说点什么吧..." readonly @click="openInput($event)"> </van-field>
        </div>
        <div class="inp-wrap fixed-inp-wrap" :class="{ active: showinput }" v-if="contentGlobalStatus == 2 || contentGlobalStatus == null">
          <van-field v-model="replyContent" :placeholder="replyPlaceholder" ref="replyInput">
            <template #button>
              <div v-if="replyContent.trim()" class="btn btn1" @click="createCommentReply">发送</div>
              <div v-else class="btn btn2">发送</div>
            </template>
          </van-field>
        </div>
      </template>
  </div>
</template>

<script>
export default {
  props: {
    archivesId: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
    selfId: {
      type: Number,
      required: true,
    },
    contentGlobalStatus: {
      type: Number,
      default: 2
    },
    fromType: { // 来源：0移动端，1pc端成长记录详情预览
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      allReplyNum: 0,
      replyList: [],
      api: this.$api.getArchivesReplyPage,
      // 显示评论输入框
      showinput: false,
      // 回复框占位文本
      replyPlaceholder: '',
      // 回复谁
      replied: '',
      repliedId: '',
      repliedName: '',
      repliedType: '',
      // 要提交的回复的内容
      replyContent: '',
    };
  },
  computed: {
    params() {
      return {
        archivesId: this.archivesId,
        companyId: this.companyId,
      };
    },
  },
  methods: {
    onload(list, res) {
      this.replyList = list;
      this.allReplyNum = res.page.totalCount;
    },
    openInput(e, item) {
      if (item) {
        if (item.reply != this.replied) {
          this.replyContent = '';
        }
        this.replyPlaceholder = `回复 ${item.replyName}`;
        this.replied = item.reply;
        this.repliedName = item.replyName;
        this.repliedType = item.replyType;
        this.repliedId = item.id;
      } else {
        this.replyPlaceholder = '说点什么吧...';
        this.replied = '';
        this.repliedName = '';
        this.repliedType = '';
      }

      this.showinput = true;
      this.$refs.replyInput.focus();
    },
    closeInput(e) {
      if (this.showinput == true) {
        this.showinput = false;
      }
    },
    async createCommentReply() {
      vant.Toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      await this.$api.createArchivesReply({
        archivesId: this.archivesId,
        companyId: this.companyId,
        replied: this.replied,
        repliedId: this.repliedId,
        repliedName: this.repliedName,
        repliedType: this.repliedType,
        reply: this.selfId,
        replyContent: {
          list: [
            {
              type: 'text',
              content: this.replyContent,
            },
          ],
        },
      });
      vant.Toast.clear();

      vant.Toast.success(`${false ? '回复' : '评论'}成功`);
      this.replyContent = '';
      this.$refs.vxlist.refresh();
      this.showinput = false;
    },
    // 删除自已的回复
    async deleteArchivesReply(id, index) {
      await this.$api.deleteArchivesReply(id);
      this.replyList.splice(index, 1);
      this.allReplyNum -= 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.common-reply {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .main {
    flex: 1 1 auto;
    .b2 {
      margin-top: calc(var(--gap) * 12);
      background-color: var(--white);
      padding: 0 calc(var(--gap) * 16);
      .til {
        display: flex;
        align-items: center;
        padding: calc(var(--gap) * 16) 0;
        .t1 {
          font-size: var(--fs-lg);
          // line-height: var(--lh-lg);
          font-weight: bold;
        }
        .t2 {
          font-size: var(--fs-sm);
          // line-height: var(--lh-sm);
          font-weight: normal;
        }
      }
      .reply {
        display: flex;
        padding-bottom: calc(var(--gap) * 24);
        .pho {
          margin-top: calc(var(--gap) * 4);
          margin-right: calc(var(--gap) * 8);
          width: calc(var(--w) * 40);
          height: calc(var(--w) * 40);
          border-radius: calc(var(--w) * 40);
          background: #000;
        }
        .info {
          flex: 1;
          .l1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .l1l {
              color: var(--g7);
              font-size: var(--fs-md);
              line-height: var(--lh-md);
            }
            .l1r {
              padding: calc(var(--gap) * 4);
            }
            .r1 {
              color: var(--g8);
            }
            .r2 {
              color: var(--c3);
            }
            .icon {
              margin-right: calc(var(--gap) * 2);
            }
          }
          .l2 {
            color: var(--g6);
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
          }
          .l3 {
            padding-top: calc(var(--gap) * 8);
            font-size: var(--fs-lg);
            line-height: var(--lh-lg);
            color: var(--g8);
            white-space:normal; 
            word-break:break-all;
            .l31 {
              color: var(--g6);
            }
          }
        }
      }
    }
  }

  .inp-wrap {
    background: var(--white);
    &.fixed-inp-wrap {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      &.active {
        z-index: 2;
      }
    }
    // 重写输入框样式
    ::v-deep .van-cell {
      padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
      .van-field__control {
        height: calc(var(--w) * 44);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        border-radius: calc(var(--w) * 44);
        background-color: var(--g2);
        padding: 0 calc(var(--w) * 24);
      }
    }
    .btn {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: calc(var(--gap) * 5);
      &.btn1 {
        color: var(--c1);
      }
      &.btn2 {
        color: var(--g5);
      }
    }
  }
}
</style>